import events from './events'

export const onInformationComplete = (value)=>{
    events.trigger('CollectInformation.informationDidComplete', value)
}

export const onConfirmationComplete = (value)=>{
    events.trigger('Confirmation.confirmationDidSubmit', value)
}


// WEBPACK FOOTER //
// ./actions/navigation.js